export class CellChangeData {
  constructor(
    public chartId: number,
    public rowData: any,
    public rowIndex: number,
  ) {}
}
